import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {FixedHeightLabels} from '../../FixedHeightLabels';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

export abstract class ButtonFixedHeightBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_BUTTON].FIXED_HEIGHT;
  }

  public getLabels(): FixedHeightLabels | undefined {
    return undefined;
  }
}
